import * as actions from "../actions/actionTypes";

const initialState = {
  dataFreshness: [],
  loading: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_DATA_FRESHNESS_SUCCESS:
      return {
        ...state,
        dataFreshness: action.results.data,
      };
    default:
      return state;
  }
};
